export default __webpack_public_path__ + "static/VehicleDetailWithAdds-d104e506a0baac38a5eea47b11f684c2.jpg";